import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { VendorRatesSchema } from '../../base/vendor.js';
export const ListAllVendorRatesApiSchema = {
    headers: ApiLambdalerAuthHeaderSchema,
    response: z.object({
        vendorRates: VendorRatesSchema.array(),
    }),
};
